/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app       = require('mag-app'),
    preloader = require('spa-preloader'),
    gettext   = require('spa-gettext'),

    profile   = require('./modules/profile');


// TODO: remove this hack, causes when key pressed, but page not loaded yet
app.activePage = {
    events: {},
    emit: function () {
        // this needs for handle early keydown
    }
};


app.addListeners({
    // all resources are loaded
    load: function load () {
        if ( MODE === 'PORTAL' ) {
            app.network = core.plugins.networkStates;

            if ( app.network.internet.linkStatus ) {
                window.pmIcons.children[0].classList.remove('disabled');
            } else {
                window.pmIcons.children[0].classList.add('disabled');
            }

            if ( app.network.wifi.linkStatus ) {
                window.pmIcons.children[1].classList.remove('disabled');
            } else {
                window.pmIcons.children[1].classList.add('disabled');
            }

            if ( app.network.ethernet.linkStatus ) {
                window.pmIcons.children[2].classList.remove('disabled');
            } else {
                window.pmIcons.children[2].classList.add('disabled');
            }

            app.network.addListener('internetStatus:change', function ( state ) {
                if ( state ) {
                    window.pmIcons.children[0].classList.remove('disabled');
                } else {
                    window.pmIcons.children[0].classList.add('disabled');
                }
            });

            app.network.addListener('wifiStatus:change', function ( state ) {
                if ( state ) {
                    window.pmIcons.children[1].classList.remove('disabled');
                } else {
                    window.pmIcons.children[1].classList.add('disabled');
                }
            });

            app.network.addListener('ethernetStatus:change', function ( state ) {
                if ( state ) {
                    window.pmIcons.children[2].classList.remove('disabled');
                } else {
                    window.pmIcons.children[2].classList.add('disabled');
                }
            });
        }

        // load localization
        gettext.load({name: core.environment.language}, function () {
            // load profile
            profile.load(app.query, function ( error, data ) {
                if ( error ) {
                    console.log(error);
                    debug.info(error);
                    window.pageMain.innerHTML = '<p>Launcher config loading error</p> ' + error;
                } else {
                    app.data = app.data || {};
                    app.data.profile = data;

                    app.pages = {
                        main: require('./pages/main')
                    };

                    preloader.once('done', function () {
                        // profile loaded
                        app.route(app.pages.main);
                        core.emit('app:ready');
                    });

                    preloader.add([
                        {url: 'img/' + app.metrics.height + '/icons/shadow.normal.png', group: 'overlay'},
                        {url: 'img/' + app.metrics.height + '/icons/shadow.active.png', group: 'overlay'}
                    ]);
                }
            });

        });
    }
});
